import { render } from "./ExchangeLogo.vue?vue&type=template&id=5da0dedf&scoped=true"
import script from "./ExchangeLogo.vue?vue&type=script&lang=js"
export * from "./ExchangeLogo.vue?vue&type=script&lang=js"

import "./ExchangeLogo.vue?vue&type=style&index=0&id=5da0dedf&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-5da0dedf"

export default script